import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController } from 'ionic-angular';

import { ScheduleMarketing as Schedule, UserMarketing as User, HelperMyRadiant } from '@providers/index';
import { FormSchedulePage, DetailSchedulePage } from '../';

@Component({
  selector: 'page-schedule',
  templateUrl: 'page.html'
})
export class SchedulePage {

  listSchedule : any ;
  tender  :any = {};
  loading :any;
  params  :any={};
  can_edit=false;
  can_delete = false;

  constructor(
    public navCtrl    : NavController,
    public navParams  : NavParams,
    private alertCtrl : AlertController,
    private toastCtrl : ToastController,
    public loadingCtrl: LoadingController,
    public userApi    : User,
    public scheduleApi: Schedule,
    public helper     : HelperMyRadiant
  ) {
    if(this.navParams.get('tender')!=undefined){
      this.tender = this.navParams.get('tender');
    }

    if (this.userApi.akses.delete_schedule) {
      this.can_delete = true;
    }

    if(this.userApi.akses.lihat_tender_group_data=='branch'){
      this.params = {
        branch_id : this.userApi.data.user_data,
        company_id : this.userApi.data.company_id,
        all_sbu : 1
      }
    }else if(this.userApi.akses.lihat_tender_group_data=='mine'){
      this.params = {
        created_by : this.userApi.data.employee_id
      }
    }else if(this.userApi.akses.lihat_tender_group_data=='fitur_user_data'){
      this.params=this.userApi.akses.lihat_tender_user_data;
    }

    if(this.userApi.akses.edit_tender_group_data=='branch'){
      if(this.tender.branch_id == this.userApi.group.user_data){
        this.can_edit=true;
      }
    }else if(this.userApi.akses.edit_tender_group_data=='all'){
      this.can_edit = true;
    }else if(this.userApi.akses.edit_tender_group_data=='mine'){
      if(this.tender.created_by == this.userApi.data.employee_id){
        this.can_edit=true;
      }
    }
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  ionViewWillEnter(){
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){
    this.showLoading();
    let params:any = {};
    if(this.tender.id!=undefined){
      params.tender_id = this.tender.id;
    }
    this.scheduleApi.get(params).subscribe((resp:any) => {
      this.listSchedule = resp.data;
      this.loading.dismiss();
    },(err) => {
      this.presentToast('Failed to Load Data.');
      this.loading.dismiss();
    });
  }

  add() {
    this.navCtrl.push(FormSchedulePage, {
      tender: this.tender
    });
  }

  edit(rec) {
    this.navCtrl.push(FormSchedulePage, {
      tender: this.tender,
      rec:rec
    });
  }

  detail(rec) {
    this.navCtrl.push(DetailSchedulePage, {
      tender: this.tender,
      rec:rec
    });
  }

  deleteSchedule(item) {
    let params = {
      id : item.id,
      tender_id : item.tender_id
    }

    let me = this,
      optionsSwal = {
      title: "Are you sure ?",   
      desc:"Once you delete schedule, you cant't undo it. ",   
      icon: "",
      dangerMode: false,
      btnCancel: "Cancel",
      btnConfirm: "Delete",
    }
    this.helper.presentSwalConfirmation(optionsSwal, () => {
      me.loading = me.helper.showLoading("Please Wait...");
      me.scheduleApi.delete(params).subscribe((resp:any) => {        
        if (resp.success) {       
          try {
            me.loading.dismiss();
          } catch (error) {
          }
          me.helper.presentToast(resp.msg);
          me.getList();
        } else {
          me.helper.presentToast(resp.msg);
        }
      }, (err) => {
        try {
          me.loading.dismiss();
        } catch (error) {

        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/marketing/schedule/page.ts